/**
 * Checks if value is null or undefined.
 *
 * @param obj - Value to check
 * @returns True if null or undefined
 */
export const is_null = obj => obj == null || obj == undefined
